import components from './components'
import computed from './computed'
import data from './data'
import directives from './directives'
import inject from './inject'
import methods from './methods'
import name from './name'
import props from './props'
import render from './render'
import watch from './watch'

export default {
  name,
  components,
  directives,
  inject,
  props: {
    ...props,
    label: {
      type: String
    }
  },
  data,
  computed,
  watch,
  methods,
  render
}
